import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class RequestTrackerService {
	private requestCount = 0;
	private readonly requestCountSubject = new Subject<number>();
	private _additionalRequestFlag = false;
	incrementRequestCount() {
		this.requestCount++;
		this.requestCountSubject.next(this.requestCount);
	}

	decrementRequestCount() {
		this.requestCount--;
		if (this.requestCount === 0 && !this.additionalRequestFlag) {
			this.requestCountSubject.next(this.requestCount);
		}
	}

	getRequestCountObservable(): Observable<number> {
		return this.requestCountSubject.asObservable();
	}

	get additionalRequestFlag(): boolean {
		return this._additionalRequestFlag;
	}

	set additionalRequestFlag(flag: boolean) {
		this._additionalRequestFlag = flag;
	}
}
